import React, { useContext } from 'react';
import { KatSpinner } from '@amzn/katal-react';
import Form from '@rjsf/material-ui';
import validator from '@rjsf/validator-ajv8';
import { FileDownloadList } from 'src/components/FileDownload/FileDownloadList';
import { Header } from 'src/react-jsonschema-katal';
import { DocumentDetails } from 'src/state/slice/models/CommonTypes';
import styled from 'styled-components';
import { generateWidgets, generateTemplates } from 'src/react-jsonschema-katal';
import UserStaticInfoSection from 'src/components/Forms/CreateCase/UserStaticInfoSection';
import { ReferralInfo } from 'src/state/slice/createCaseSlice';
import { DDMAttributes } from 'src/integration/ddm/providers/DDMAttributesProvider';
import { FileAttachmentsConstants } from 'src/constants/ProjectConstants';
import { UiSchema } from '@rjsf/utils';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

const ViewCaseContainer = styled.div``;
export interface ViewCaseFormProps extends DDMAttributes {
  userStaticInformation: ReferralInfo;
  documentList: Array<DocumentDetails> | undefined;
}

const ViewCaseForm: React.FC<ViewCaseFormProps> = ({
  formData, //responsible for hydrating the ReactJSON form.
  userStaticInformation,
  documentList,
  createCaseStaticSchema,
  createCaseUiSchema,
  createCaseSchema,
}) => {
  if (!userStaticInformation || !formData) {
    return <KatSpinner />;
  }

  const viewCaseUiSchema: UiSchema = {
    ...createCaseUiSchema,
    'ui:submitButtonOptions': {
      norender: true, //the default submit button should not render.
    },
  };

  const { caseDetailsBundle } = useContext(TranslationContext);

  return (
    <ViewCaseContainer>
      <UserStaticInfoSection
        properties={userStaticInformation}
        schema={createCaseStaticSchema}
      />
      <Form
        widgets={generateWidgets()}
        disabled={true}
        uiSchema={viewCaseUiSchema}
        formData={formData}
        schema={createCaseSchema}
        validator={validator}
        templates={generateTemplates()}
      />
      <FileDownloadList
        attachments={documentList}
        header={
          <Header
            title={caseDetailsBundle.getMessage(
              FileAttachmentsConstants.ATTACHMENTS_HEADER,
            )}
          />
        }
      />
    </ViewCaseContainer>
  );
};

export default ViewCaseForm;
